






















import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import "./scss/editormd.1.scss";

import Marked from "marked";

import EditorMD from "./libs/editormd";
import * as ResouceManager from "./libs/ResourceManager";
import * as utils from "./libs/utils";

@Component({
  components: {}
})
export default class MarkdownReader extends Vue {
  private dValue: any = null;
  private dPreviewHtml = "";
  private ready: boolean;
  private settings: any = {};
  private _dynamicContainer: any;

  // @Prop({ type: [Object], default: () => {} })
  // private options: object;

  @Prop({ type: [String], default: "" })
  private value: string;

  // 显示风格

  /**
   * 编辑器主题
   *
   * 编辑器整体皮肤主题，默认支持【default】、【dark】
   * 默认值：default
   * */
  @Prop({
    type: [String],
    default: "default",
    validator: theme => {
      return EditorMD.themes.indexOf(theme) > -1;
    }
  })
  private theme = "default";

  /**
   * 编辑器预览视图主题
   *
   * 编辑器预览视图区主题，支持【default】、【dark】
   * 默认值：default
   * */
  @Prop({
    type: [String],
    default: "default",
    validator: theme => {
      return EditorMD.previewThemes.indexOf(theme) > -1;
    }
  })
  private previewTheme = "default";

  /**
   * 阅读或预览模式下是否高亮代码片段
   *
   * 默认值：true
   * */
  @Prop({ type: [Boolean], default: true })
  private previewCodeHighlight = true;

  /**
   * 指定编辑器高度
   *
   * 支持格式：640、"640px"、"auto"
   * 默认值：640
   * */
  @Prop({ type: [String, Number], default: 640 })
  private height: string | number = 640;

  /**
   * 指定编辑器多语言
   *
   * 支持格式：zh-cn、us-en
   * 默认值：zh-cn
   * */
  @Prop({ type: [String], default: "zh-ch" })
  private lang = "zh-ch";

  // 功能开关

  /**
   * 是否开启Html
   *
   * 默认值：false
   * */
  @Prop({ type: [Boolean], default: true })
  private htmlDecode = true;

  /**
   * TOC内容目录
   *
   * 是否开启[TOC]支持
   * 默认值：false
   * */
  @Prop({ type: [Boolean], default: false })
  private toc;

  /**
   * @链接高亮功能
   *
   * 是否开启@链接功能，支持链接内容高亮和外部链接跳转
   * 默认值：false
   * */
  // @Prop({ type: [Boolean], default: false })
  // private atLink: boolean = false;

  /**
   *  @提及功能，关联系统用户
   *
   *  默认值：false
   * */
  @Prop({ type: [Boolean], default: true })
  private atMention: boolean;

  @Prop({ type: [String], default: "https://www.datafountain.cn/users/" })
  private mentionUrl: string;

  /**
   * 提及方法，供外部自定义获取提及的内容
   * */
  // @Prop({ type: [Function] })
  // private mention = () => {};

  /**
   *  邮箱地址高亮
   *
   *  默认值: false
   * */
  @Prop({ type: [Boolean], default: true })
  private emailLink = true;

  /**
   * 分页符
   *
   *  是否支持解析分页符  [========]
   *  默认值: true
   * */
  @Prop({ type: [Boolean], default: true })
  private pageBreak = true;

  /**
   * Github Flavored Markdown风格的任务列表
   *
   * 是否开启GFM任务列表功能
   * 默认值: true
   * */
  @Prop({ type: [Boolean], default: true })
  private taskList = true;

  /**
   * emoji表情符
   *
   * 是否开启emoji表情符支持，目前支持Github emoji， Twitter Emoji、
   * fontAwesome icon emoji :fa-xxx: > Using fontAwesome icon web fonts
   * 默认值: false
   * */
  @Prop({ type: [Boolean], default: true })
  private emoji = true;

  /**
   * 数学公式，TeX(LaTeX), based on KaTeX
   *
   * 是否开启数学公式支持
   * 默认值: false
   * */
  @Prop({ type: [Boolean], default: true })
  private tex = true;

  /**
   * FlowChart流程图
   *
   * 是否开启flowChart流程图支持， 基于flowChart.js，only support IE9+
   * 默认值: false
   * */
  // @Prop({ type: [Boolean], default: false })
  // private flowChart = false;

  /**
   * Sequence to sequence 模型图
   *
   * 是否开启Sequence to sequence模型图解析支持，基于sequenceDiagram.js，only support IE9+
   * 默认值: false
   * */
  // @Prop({ type: [Boolean], default: false })
  // private sequenceDiagram = false;

  get classes() {
    const classes = [];
    // 主题
    if (this.theme) {
      classes.push("markdown-panel__theme-" + this.theme);
    }
    return classes;
  }

  // get toolbarItems() {
  //     return EditorMD.toolbarModes[this.d_toolbar_mode] || [];
  // }

  private created() {
    this.$nextTick(() => {
      this._dynamicContainer = this.$refs.container;
    });
  }

  private async mounted() {
    this.dValue = this.$props.value; // v-mode
    await this._setupResources();
    this.ready = true;
    if (this.dValue) {
      this.convert(this.dValue);
    }
  }

  private async _setupResources() {
    const resouces = [ResouceManager.loadJQueryOrZepto()];
    // prettify
    if (this.previewCodeHighlight) {
      resouces.push(ResouceManager.loadPrettify());
    }
    // tex
    if (this.tex) {
      resouces.push(ResouceManager.loadKaTex());
    }
    // flow chart or sequence diagram
    // if (this.flowChart || this.sequenceDiagram) {
    //     // TODO:
    // }

    await Promise.all(resouces);
  }

  // resize handler

  private convert(content) {
    const rendererOptions = {
      toc: this.toc,
      tocStartLevel: 1,
      pageBreak: this.pageBreak,
      taskList: this.taskList,
      emoji: this.emoji,
      tex: this.tex,
      atLink: false, // for @link
      emailLink: this.emailLink, // for mail address auto link
      mentionLink: this.atMention,
      mentionLinkBase: this.mentionUrl,
      // flowChart: this.flowChart,
      // sequenceDiagram: this.sequenceDiagram,
      previewCodeHighlight: this.previewCodeHighlight
    };

    const toc = [];
    const markedOptions = {
      renderer: EditorMD.createMarkedRender(toc, rendererOptions),
      gfm: true,
      tables: true,
      breaks: true,
      pedantic: false,
      // sanitize: !!this.htmlDecode,  // 关闭忽略HTML标签，即开启识别HTML标签，默认为false
      smartLists: true,
      smartypants: true,
      highlight: function(code: any, lang: any, callback: any) {
        // let out = Prism.highlight(code, Prism.languages[lang || 'markup']);
        // return out;
      }
    };

    // Marked.setOptions(markedOptions);
    let newMarkdownDoc = Marked(content, markedOptions);
    newMarkdownDoc = EditorMD.filterHTMLTags(newMarkdownDoc, this.htmlDecode);
    // 没有变化
    // 用户通过回车键入多空行时，markdown解析出来的html不变
    if (newMarkdownDoc === this.dPreviewHtml) {
      return;
    }

    this.dPreviewHtml = newMarkdownDoc;

    // hightlight preview code
    if (this.previewCodeHighlight) {
      this.highlightPreviewCode();
    }

    // toc
    if (this.toc) {
      const tocHtml = this.getTocHtml(toc);
      this.$nextTick(() => {
        setTimeout(() => {
          const toc =
            this.$refs.preview &&
            (this.$refs.preview as any).querySelectorAll(
              ".markdown-toc-container"
            );
          if (toc && toc.length) {
            for (let i = 0, len = toc.length; i < len; i++) {
              toc[i].innerHTML = tocHtml;
            }
          }
        }, 0);
      });
    }

    // tex
    if (this.tex) {
      this.katexRender();
    }
  }

  private convertToHtml(content: any) {
    const settings = this.settings;

    const rendererOptions = {
      toc: this.toc,
      // tocm: settings.tocm,
      tocStartLevel: settings.tocStartLevel,
      pageBreak: this.pageBreak,
      taskList: this.taskList,
      emoji: this.emoji,
      tex: this.tex,
      atLink: false, // for @link
      emailLink: this.emailLink, // for mail address auto link
      mentionLink: this.atMention,
      mentionLinkBase: this.mentionUrl,
      // flowChart: this.flowChart,
      // sequenceDiagram: this.sequenceDiagram,
      previewCodeHighlight: this.previewCodeHighlight
    };

    const toc = [];
    const markedOptions = {
      renderer: EditorMD.createMarkedRender(toc, rendererOptions),
      gfm: true,
      tables: true,
      breaks: true,
      pedantic: false,
      sanitize: !!this.htmlDecode, // 关闭忽略HTML标签，即开启识别HTML标签，默认为false
      smartLists: true,
      smartypants: true,
      highlight: function(code: any, lang: any, callback: any) {
        // let out = Prism.highlight(code, Prism.languages[lang || 'markup']);
        // return out;
      }
    };

    // Marked.setOptions(markedOptions);
    let newMarkdownDoc = Marked(content, markedOptions);
    newMarkdownDoc = EditorMD.filterHTMLTags(newMarkdownDoc, this.htmlDecode);

    return newMarkdownDoc;
  }

  private getTocHtml(toc: any[], tocDropdown?: any, startLevel?: any) {
    let html = "";
    let lastLevel = 0;
    const classPrefix = EditorMD.classPrefix;

    startLevel = startLevel || 1;

    for (let i = 0, len = toc.length; i < len; i++) {
      const text = toc[i].text;
      const level = toc[i].level;

      if (level < startLevel) {
        continue;
      }

      if (level > lastLevel) {
        html += "";
      } else if (level < lastLevel) {
        html += new Array(lastLevel - level + 2).join("</ul></li>");
      } else {
        html += "</ul></li>";
      }

      html +=
        '<li><a class="toc-level-' +
        level +
        '" href="#' +
        text +
        '" level="' +
        level +
        '">' +
        text +
        "</a><ul>";
      lastLevel = level;

      if (i === len - 1 && lastLevel > startLevel) {
        html += new Array(lastLevel - startLevel + 2).join("</ul></li>");
      }
    }

    return `<div class="markdown-toc ${classPrefix}markdown-toc">
                                    <ul class="markdown-toc-list">${html}</ul>
                             </div>`.replace(/\r?\n?<ul><\/ul>/g, "");
  }

  /**
   * Katex render
   */
  private katexRender() {
    // if (this._timer === null) {
    //     return this;
    // }

    this.$nextTick(() => {
      const windowRef: any = window;
      if (!windowRef.katex) return;

      setTimeout(() => {
        const prenodes =
          this.$refs.preview &&
          (this.$refs.preview as any).querySelectorAll(".markdown-panel__tex");
        if (!prenodes) return;
        for (let i = 0; i < prenodes.length; i++) {
          const node = prenodes[i];
          windowRef.katex.render(node.textContent, node, { strict: false });
          node.querySelector(".katex").style.fontSize = "1.6em";
        }
      }, 0);
    });
  }

  /**
   * 高亮预览HTML的pre代码部分
   * highlight of preview codes
   *
   * @returns {editormd}             返回editormd的实例对象
   */
  private highlightPreviewCode() {
    const windowRef: any = window;
    this.$nextTick(() => {
      setTimeout(() => {
        const prenodes =
          this.$refs.preview &&
          (this.$refs.preview as any).querySelectorAll("pre:not(.prettyprint)");
        if (windowRef.PR && windowRef.PR.prettyPrint && prenodes) {
          utils.addClass(prenodes, "prettyprint", "linenums");
          windowRef.PR.prettyPrint();
        }
      }, 0);
    });
  }

  @Watch("value")
  private valueWatcher(newValue: any) {
    // 调用组件时直接通过v-mode传值
    // codemirror change事件时emit input事件
    if (newValue !== this.dValue) {
      this.dValue = newValue;
      this.ready && this.convert(newValue);
    }
  }
}
